import React, { Component } from 'react'
import { connect } from "react-redux";
import { Cookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUseronboardingInfo } from '../../../../../actions/loginActions';
import EmailVerifiedPop  from './EmailConfiramation/EmailVerifiedPopup';
import EmailConfirmationPopup  from './EmailConfiramation/EmailConfirmationPopup';
import { SOCKET_CONNECTION, bootPendingIntercom } from '../../../../../utils';


const cookies = new Cookies();
// shared across Verify instances (Init and Onboarding both render it) so that once "Let's Go" is clicked, a late socket event or the access 2 -> 1 update can't reopen the popup
let verifiedPopupDismissed = false;

const Verification = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return <Verify {...props} dispatch={dispatch} navigate={navigate} />
}
class Verify extends Component {

    constructor(props) {
        super(props)
        const { userData } = this.props;

        this.state = {
            confirmPopup: userData?.user?.access == 2 || userData?.user?.email_confirmation == 0 ? true : false,
            verifiedPopUp: !verifiedPopupDismissed && userData?.user?.access != 2 && cookies && cookies.get('emailConfirmation') == "true" ? true : false
        }
    }

    componentDidMount() {
        const { userData, navigate } = this.props;

        this.socketEvent = `update${userData?.user?.id}`;
        this.onVerifiedSocket = (data) => {
            const { getUserDetails, verificationProduct } = this.props;
            this.setState({ confirmPopup: false, verifiedPopUp: !verifiedPopupDismissed }, () => { getUserDetails(navigate); verificationProduct() })
        };
        SOCKET_CONNECTION.on(this.socketEvent, this.onVerifiedSocket);

        if (this.state.confirmPopup && userData?.user?.access != 2) {
            this.setState({ confirmPopup: false })
        }
    }
    componentWillUnmount() {
        SOCKET_CONNECTION.off(this.socketEvent, this.onVerifiedSocket);
    }

    componentDidUpdate(prevProps){
        if(prevProps.userData?.user?.access != this.props.userData?.user?.access){
           if(this.props.userData?.user?.access ==1) this.setState({ confirmPopup: false, verifiedPopUp: !verifiedPopupDismissed })
        }
      }

    onClickToCloseConfirm = event => {
        if (this.state.verifiedPopUp) {
            verifiedPopupDismissed = true;
            this.setState({ verifiedPopUp: false }, () => {
                this.props.getAllNetwork();
                if (this.props.onEmailVerified) this.props.onEmailVerified();
                bootPendingIntercom();
            });
        }
    }

    render() {
        const { confirmPopup, verifiedPopUp } = this.state;
        const { userData } = this.props;

        return <>
            {userData?.user?.access == 2 || userData?.user?.access == 1 ? <> {verifiedPopUp ? <EmailVerifiedPop onClickToCloseConfirm={this.onClickToCloseConfirm} /> : confirmPopup ? <EmailConfirmationPopup /> : null}  </> : null}
        </>
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.authenticated.userData,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getUserDetails: (callback) => dispatch(getUseronboardingInfo(callback, true)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Verification)